<template>
  <div class="home light-theme">
    <!-- 添加调试信息显示 -->
    <div v-if="false"
      style="position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.8); color: white; padding: 10px; z-index: 9999;">
      isCollapsed: {{ isCollapsed }}
    </div>

    <div class="bodydiv">
      <aside :class="{ collapsed: isCollapsed }" @mouseenter="showCollapseIcon = true"
        @mouseleave="showCollapseIcon = false">
        <div class="sidebar-toggle-btn" @click.stop="toggleCollapse" v-if="!isCollapsed && showCollapseIcon">
          <i class="fas fa-angle-double-left"></i>
        </div>
        <div class="logotitle" v-show="!isCollapsed">
          <img @click="backindex()" :src="home_logo" alt="EasyNote" />
        </div>

        <!-- 展开按钮独立为一个菜单项，在折叠状态下显示，使用相反方向的图标 -->
        <div class="sidebar-toggle-btn expand-btn" v-if="isCollapsed" @click.stop="toggleCollapse">
          <i class="fas fa-angle-double-right"></i>
        </div>

        <ul>
          <li :class="{ liactiveis: asidekey == 'home' }" @click="gopageurl('home')">
            <img :src="asidekey == 'home' ? dashboardActive : dashboardNormal" alt="" />
            <span v-show="!isCollapsed">Dashboard</span>
          </li>
          <li :class="{ liactiveis: asidekey == 'howtouse' }" @click="gopageurl('howtouse')">
            <img :src="asidekey == 'howtouse' ? howtouseActive : howtouseNormal" alt="" />
            <span v-show="!isCollapsed">How to use</span>
          </li>
          <li :class="{ liactiveis: asidekey == 'supports' }" @click="gopageurl('supports')">
            <img :src="asidekey == 'supports' ? supportsActive : supportsNormal" alt="" />
            <span v-show="!isCollapsed">Supports</span>
          </li>
          <li @click="JoinDiscord" v-if="false">
            <img :src="discordlogo" alt="" />
            <span v-show="!isCollapsed">Join Discord</span>
          </li>
          <li :class="{ liactiveis: asidekey == 'settings' }" @click="gopageurl('settings')">
            <img :src="asidekey == 'settings' ? settingiconActive : settingiconNormal" alt="" />
            <span v-show="!isCollapsed">Settings</span>
          </li>
        </ul>

        <div class="gopaypage" @click="gopaypage" v-show="!isCollapsed">
          ✨ Upgrade to Premium
        </div>
        <div class="acount" @mouseenter="showpaybtn = true" @mouseleave="showpaybtn = false"
          @click="gopageurl('acount')">
          <div class="plan-bubble" v-if="!isCollapsed">
            <div class="bubble-row" @click="gopageurl('settings')">
              <span>Your Plan:</span>
              <span>{{ planname }}</span>
            </div>
          </div>
          <div class="signin" v-if="!isCollapsed">
            <img :src="userimg" alt="" />
            <span>{{ email }}</span>
          </div>
          <div class="signin-collapsed" v-if="isCollapsed">
            <img :src="userimg" alt="" />
          </div>
        </div>
      </aside>
      <main>
        <HomePage v-if="asidekey == 'home'" @chooseaside="chooseaside" @gopaypage="gopaypage" :showhome_home="showhome">
        </HomePage>
        <HomeSetting v-if="asidekey == 'settings'"></HomeSetting>
        <HomeSupports v-if="asidekey == 'supports'"></HomeSupports>
        <HomeHowtouse v-if="asidekey == 'howtouse'"></HomeHowtouse>
      </main>
    </div>
    <popupdeleteaccount v-if="isdeletepopup" />
    <popup_price v-if="ispricepopup" @closePricePopup="closePricePopup" />
    <popup_record_leave 
      v-if="isrecordleavepopup" 
      @cancel="closeRecordLeavePopup" 
      @confirmLeave="handleConfirmLeave"
      ref="recordLeavePopup" />
  </div>
</template>

<script>
import HomePage from "@/views/pages/home_page/HomePage.vue";
import HomeSetting from "@/views/pages/home_page/home_settings.vue";
import HomeSupports from "@/views/pages/home_page/home_supports.vue";
import HomeHowtouse from "@/views/pages/home_page/home_howtouse.vue";
import popupdeleteaccount from "@/views/pages/home_page/popups/popup_deletea.vue";
import popup_price from "@/views/pages/index_page/popups/popup_price.vue";
import popup_record_leave from "@/views/pages/home_page/popups/popup_record_leave.vue";
export default {
  components: {
    HomePage,
    HomeSetting,
    HomeSupports,
    HomeHowtouse,
    popupdeleteaccount,
    popup_price,
    popup_record_leave
  },
  name: "HomeIndexpage",
  data() {
    return {
      // 非选中状态图标
      dashboardNormal: require("@/assets/images/home/normal/dashboard.png"),
      howtouseNormal: require("@/assets/images/home/normal/huojian.png"),
      supportsNormal: require("@/assets/images/home/normal/supports.png"),
      settingiconNormal: require("@/assets/images/home/normal/setting.png"),

      // 选中状态图标
      dashboardActive: require("@/assets/images/home/active/dashboard.png"),
      howtouseActive: require("@/assets/images/home/active/huojian.png"),
      supportsActive: require("@/assets/images/home/active/supports.png"),
      settingiconActive: require("@/assets/images/home/active/setting.png"),

      discordlogo: require("@/assets/images/home/discordlogo.png"),

      // vipicon: require("../assets/images/home/vip_gif1.gif"),

      userimg: require("../assets/images/home/userimg.png"),
      asidekey: "home",
      home_logo: require("../assets/images/index/logo1.png"),
      showpaybtn: false,
      email: "",

      planname: "--",

      isdeletepopup: false,

      isCollapsed: false,
      showhome: {
        showhome_home: '',
        timestr: ''
      },
      showCollapseIcon: false, // 控制折叠图标显示
      ispricepopup: false,
      isrecordleavepopup: false,
      pendingAction: null, // 存储被暂停的操作
      isBeforeUnloadTriggered: false, // 添加新的标记
    };
  },
  mounted() {
    // 在挂载时读取折叠状态
    try {
      const savedState = this.$cookies.get("menuCollapsed");
      if (savedState !== null && savedState !== undefined) {
        this.isCollapsed = JSON.parse(savedState);
      }
    } catch (error) {
      console.error("Error reading collapse state:", error);
    }

    // 为浏览器前进/后退按钮监听添加初始历史状态
    history.pushState(null, '', window.location.href);

    // cookies中获取登录信息。

    // console.log("Route params:", this.$route);
    if (this.$route.params && this.$route.params.pagekey) {
      this.chooseaside(this.$route.params.pagekey);
    } else {
      this.chooseaside("home");
    }

    if (!!this.$cookies.get("userlogin") && !!this.$cookies.get("username")) {
      this.getnotelists();
    }

    this.email = this.$cookies.get("email");
    this.getminfo();
  },
  created() {
    // 添加事件监听
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('popstate', this.handlePopState);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('popstate', this.handlePopState);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleWindowFocus);
  },
  watch: {
    '$route'(to,) {
      // 检查路由参数的变化
      const pagekey = to.params.pagekey;
      if (pagekey) {
        // 根据 URL 中的 pagekey 展示相应组件
        this.chooseaside(pagekey);
      }
    },
  },
  methods: {
    closePricePopup() {
      this.ispricepopup = false;
    },
    closeRecordLeavePopup() {
      this.isrecordleavepopup = false;
      this.pendingAction = null; // 清除待执行的操作
    },
    
    /**
     * 检查录音状态
     * @returns {boolean} 是否正在录音
     */
    checkRecordingState() {
      // 检查cookie中的录音状态标记
      const ischilddeep = this.$cookies.get("ischilddeep", '');
      return ischilddeep === 'islive';
    },

    /**
     * 显示录音离开确认弹窗
     * @param {Function} action - 被暂停的操作函数
     */
    showRecordLeavePopup(action = null) {
      this.pendingAction = action; // 存储待执行的操作
      this.isrecordleavepopup = true;
      // 使用 nextTick 确保DOM更新后再调用组件方法
      this.$nextTick(() => {
        if (this.$refs.recordLeavePopup) {
          this.$refs.recordLeavePopup.openModal();
        }
      });
    },

    /**
     * 处理确认离开
     */
    handleConfirmLeave() {
      // 清除录音状态
      this.$cookies.set('ischilddeep', '');
      
      // 关闭弹窗
      this.isrecordleavepopup = false;
      
      // 执行被暂停的操作
      if (this.pendingAction && typeof this.pendingAction === 'function') {
        this.pendingAction();
      }
      
      // 清除待执行的操作
      this.pendingAction = null;
    },
    async getminfo() {
      try {
        const subid = this.$cookies.get("subid");
        const response = await this.$axios.post("/api/getminfo/", {
          subid: subid,
        });
        const resdata = response.data;
        if (resdata.code == 200) {
          this.planname = resdata.minfo;

        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    handleBeforeUnload(event) {
      const ischilddeep = this.$cookies.get("ischilddeep", '');
      if (ischilddeep == 'islive') {
        // 不立即清除录音状态，等待用户实际选择
        // 设置一个标记，表示用户触发了离开操作
        this.isBeforeUnloadTriggered = true;
        
        const message = 'You have unsaved changes. Do you really want to leave?';
        event.returnValue = message; // 标准
        return message; // 旧版
      }
    },
    
    /**
     * 处理浏览器前进/后退按钮点击事件
     */
    handlePopState(event) {
      // 检查是否正在录音
      const isRecording = this.checkRecordingState();
      if (isRecording) {
        // 如果正在录音，阻止默认的前进/后退行为
        event.preventDefault();
        // 向前推进一个历史状态，抵消后退操作
        history.pushState(null, '', window.location.href);
        // 显示录音离开确认弹窗
        this.showRecordLeavePopup(() => {
          // history.back();
          this.gopageurl('home');

        });
        return;
      }
      // 如果没有在录音，允许正常的前进/后退
    },
    async getnotelists() {
      console.log("getnotelists");
    },
    backindex() { 
      // 检查是否正在录音
      const isRecording = this.checkRecordingState();
      if (isRecording) {
        this.showRecordLeavePopup(() => {
          this.$router.push({ name: "index" });
        });
        return; // 阻止页面跳转
      }

      this.$router.push({ name: "index" });
    },
    async testapi() {
      // 测试axios
      try {
        console.log(
          "Request URL:",
          this.$axios.defaults.baseURL + "/api/hello"
        ); // 打印URL
        const res = await this.$axios.get("/api/hello");
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    gopaypage() {

      // 检查是否正在录音
      const isRecording = this.checkRecordingState();
      if (isRecording) {
        this.showRecordLeavePopup(() => {
          this.$router.push({
            name: "IndexPage", // 目标路由的名称
            params: { pagekey: "price" }, // 通过 params 传递参数
            // query: { category: "electronics" }, // 通过 query 传递参数
          });
        });
        return; // 阻止页面跳转
      }

      this.$router.push({
        name: "IndexPage", // 目标路由的名称
        params: { pagekey: "price" }, // 通过 params 传递参数
        // query: { category: "electronics" }, // 通过 query 传递参数
      });

      // this.ispricepopup = true;    // 弹窗方式
    },
    gopageurl(key) {
      // console.log("gopageurl", key);
      
      // 检查是否正在录音
      const isRecording = this.checkRecordingState();
      if (isRecording) {
        this.showRecordLeavePopup(() => {
          if (key == 'home') {
            this.showhome = {
              showhome_home: 'home',
              timestr: new Date().getTime()
            };
          }

          this.$router.push({
            name: "Homeindex_key", // 目标路由的名称
            params: { pagekey: key }, // 通过 params 传递参数
            // query: { category: "electronics" }, // 通过 query 传递参数
          });
        });
        return; // 阻止页面跳转
      }

      if (key == 'home') {
        this.showhome = {
          showhome_home: 'home',
          timestr: new Date().getTime()
        };
      }

      this.$router.push({
        name: "Homeindex_key", // 目标路由的名称
        params: { pagekey: key }, // 通过 params 传递参数
        // query: { category: "electronics" }, // 通过 query 传递参数
      });
    },
    chooseaside(key) {
      if (key == "acount") {
        key = "settings";
        this.showpaybtn = true;
      }
      this.asidekey = key;
    },
    JoinDiscord() {
      window.open("https://discord.gg/ffkFvpVBjt");
    },
    // 切换折叠状态并保存到 cookie
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      // 当展开时，暂时保持图标可见
      if (!this.isCollapsed) {
        this.showCollapseIcon = true;
        // 短暂延迟后，如果鼠标不在侧边栏上，则隐藏图标
        setTimeout(() => {
          if (!this.$el.querySelector('aside:hover')) {
            this.showCollapseIcon = false;
          }
        }, 2000);
      }
      try {
        this.$cookies.set("menuCollapsed", JSON.stringify(this.isCollapsed), {
          path: "/",
          expires: 30  // 使用数字而不是字符串，表示天数
        });
      } catch (error) {
        console.error("Error saving collapse state:", error);
      }
    },

    // 添加检查和更新折叠状态的方法
    checkAndUpdateCollapsedState() {
      try {
        const savedState = this.$cookies.get("menuCollapsed");
        if (savedState !== null && savedState !== undefined) {
          const parsedState = JSON.parse(savedState);
          if (this.isCollapsed !== parsedState) {
            this.isCollapsed = parsedState;
          }
        }
      } catch (error) {
        console.error("Error checking collapse state:", error);
      }
    },

    /**
     * 处理页面可见性变化
     * 当页面变为隐藏状态且用户之前触发了beforeunload，说明用户选择了离开
     */
    handleVisibilityChange() {
      if (this.isBeforeUnloadTriggered) {
        if (document.visibilityState === 'hidden') {
          // 页面变为隐藏，可能是用户选择离开，延迟检测
          setTimeout(() => {
            // 如果标记还存在且页面仍然隐藏，说明用户确实离开了
            if (this.isBeforeUnloadTriggered && document.visibilityState === 'hidden') {
              this.$cookies.set('ischilddeep', '');
              this.isBeforeUnloadTriggered = false;
              console.log('User confirmed to leave, recording state cleared');
            }
          }, 1000); // 1秒延迟，避免误判
        } else if (document.visibilityState === 'visible') {
          // 页面重新可见，用户选择了留下
          this.isBeforeUnloadTriggered = false;
          console.log('User canceled leaving, recording state preserved');
        }
      }
    },
    
    /**
     * 处理窗口重新获得焦点
     * 当窗口重新获得焦点且用户之前触发了beforeunload，说明用户选择了留下
     */
    handleWindowFocus() {
      if (this.isBeforeUnloadTriggered) {
        // 用户选择了留在页面，重置标记，保持录音状态
        this.isBeforeUnloadTriggered = false;
        console.log('User canceled leaving via focus event, recording state preserved');
      }
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   拦截路由返回（后退按钮）时的离开
  //   const ischilddeep = this.$cookies.get("ischilddeep",''); 
  //   if (ischilddeep == 'islive') {
  //     // 提示用户是否保存数据
  //     const answer = window.confirm('You have unsaved data, are you sure you want to leave?');
  //     this.$cookies.set('ischilddeep','')
  //     if (answer) {
  //       next(); // 用户确认离开，继续路由跳转
  //     } else {
  //       next(false); // 用户取消，阻止路由跳转
  //     }
  //   } else {
  //     next(); // 没有修改数据，继续路由跳转
  //   }
  // },
  // 添加 beforeUpdate 钩子，在每次更新前检查 cookie 状态
  beforeUpdate() {
    this.checkAndUpdateCollapsedState();
  },
};
</script>

<style lang="less" scoped>
@import "../assets/styles/home.less";

.acount {
  position: relative;

  .plan-bubble {
    position: absolute;
    bottom: 100%;
    right: 0;
    background: rgba(47, 45, 58, 0.95);
    border-radius: 10px;
    padding: 15px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    width: 200px;

    // 添加小三角
    &:after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid rgba(47, 45, 58, 0.95);

    }

    .bubble-row {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      color: #fff;
      font-size: 13px;

      span:first-child {
        color: #9ca3af;
      }
    }

    .bubble-divider {
      height: 1px;
      background: rgba(255, 255, 255, 0.1);
      margin: 12px 0;
    }
  }
}

aside {
  position: relative;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;

  .sidebar-toggle-btn {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 100;

    i {
      font-size: 18px;
      color: #fff;
      padding: 8px;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(115, 102, 255, 0.2), rgba(168, 95, 255, 0.2));
      box-shadow: 0 3px 8px rgba(115, 102, 255, 0.3);
      transition: all 0.3s ease;
    }

    &:hover i {
      transform: scale(1.1);
      background: linear-gradient(135deg, rgba(115, 102, 255, 0.3), rgba(168, 95, 255, 0.3));
      box-shadow: 0 4px 10px rgba(115, 102, 255, 0.4);
    }
  }

  .expand-btn {
    position: relative;
    top: 0;
    right: 0;
    margin-top: 15px;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.05);
    }

    100% {
      transform: scale(1);
    }
  }

  &.collapsed {
    width: 60px;
    min-width: 60px;

    li {
      justify-content: center;
      padding: 10px 0;

      img {
        transform: scale(1.1);
        margin-right: 0;
      }
    }


    .signin {
      justify-content: center;
      padding: 10px 0;

      img {
        margin-right: 0;
        transform: scale(1.1);
      }

      span {
        display: none;
      }
    }

    .logotitle,
    .gopaypage {
      opacity: 0;
      transform: translateX(-20px);
      visibility: hidden;
    }
  }

  li,
  .signin {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

    img {
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    span {
      transition: opacity 0.2s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
  }

  .logotitle,
  .gopaypage {
    transition: opacity 0.2s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
}

.signin {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  span {
    transition: opacity 0.15s ease, transform 0.2s ease;
    white-space: nowrap;
  }
}

/* 添加动画效果 */
@keyframes popIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes slideIn {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

li img,
.signin img {
  animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

li span,
.signin span {
  animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  animation-delay: 0.1s;
}

/* 新添加的展开按钮过渡动画 */
.expand-menu-button {
  animation: fadeIn 0.5s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
